import React from "react";
import { Chip } from "@mui/material";
import { FiberManualRecord } from "@mui/icons-material";
import { colors } from "../../constants/colors";

// const StyledIcon = styled(FiberManualRecord)(({ theme }) => ({
//   fontSize: "12px", // Adjust the size
//   color: theme.palette.secondary.main, // Adjust the color
// }));

type Props = {
  label: string;
  icon?: React.ReactElement; // Changed to React.ReactElement
  type: "outlined" | "filled";
  color:
    | "default"
    | "primary"
    | "secondary"
    | "error"
    | "info"
    | "success"
    | "warning";
  width?: string;
};

const CustomStatus: React.FC<Props> = ({ label, icon, type, color, width}) => {
  let handleMainColor = "";
  let bgColorWithOpacity = "";

  const convertHexToRGBA = (hex: string, opacity: number) => {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  };

  if (color === "success") {
    handleMainColor = colors.success3;
  } else if (color === "error") {
    handleMainColor = colors.red;
  } else if (color === "warning") {
    handleMainColor = colors.warning;
  } else if (color === "info") {
    handleMainColor = colors.sky;
  } else if (color === "secondary") {
    handleMainColor = colors.blue;
  } else if (color === "default") {
    handleMainColor = colors.gray;
  } else {
    handleMainColor = colors.primary;
  }

  bgColorWithOpacity = convertHexToRGBA(handleMainColor, 0.1);

  const styledIcon = (icon: React.ReactElement) => {
    return React.cloneElement(icon, {
      style: { fontSize: "12px", color: handleMainColor },
    });
  };

  const defaultIcon = styledIcon(<FiberManualRecord />);

  return (
    <Chip
      label={label}
      variant={type}
      color={color}
      icon={icon ? styledIcon(icon) : defaultIcon}
      sx={{
        backgroundColor: bgColorWithOpacity,
        color: handleMainColor,
        borderColor: handleMainColor,
        borderStyle: "solid",
        fontWeight: "bold",
        width: width,
        "& .MuiChip-icon": {
          color: handleMainColor,
        },
      }}
    />
  );
};

export default CustomStatus;
